import React, { useContext, useEffect, useState } from "react";
import { TextField, Box, Typography } from "@mui/material";
import { UserContext } from "context/userContext";
import "react-phone-number-input/style.css";
import getLieu from "services/lieuService";
import getEntity from "services/entityService";
import getTag from "services/tagService";
import MDButton from "components/MDButton";
import handleLieuChange from "helpers/lieuHelper";
import AutoCompleteComponent from "components/AutoCompleteComponent";
import { ERROR, SUCCESS } from "constant/message";
import fetchCustomProfil from "helpers/profilHelper";
import handleSelectChange from "helpers/selectHelper";
import { useNavigate } from "react-router-dom";
// import { useQuery } from "@tanstack/react-query";
import CONFIG from "config";
import {
  SUPERVISEUR_ROLE,
  ADMIN_REGION_ROLE,
  ADMIN_DEPARTEMENTAL_ROLE,
  AGENT_ROLE,
  RESPONSABLE_FERME,
  ELEVEUR,
  PROPRIETAIRE,
  // INSEMINATEUR_ROLE,
  SUPER_ADMIN_ROLE,
  ADMIN_PAYS_ROLE,
} from "constant/role";
import { LAST_PATH } from "constant";
import { searchUser } from "services/userService";
import userInfos, {
  checkRoleExist,
  CurrentUserNiveau /* , CurrentUserEntite */,
} from "utils/userInfos";
import {
  LIST_ESPECE_CATEGORY as LIST_ESPECE_CATEGORY_OTHER,
  LIST_ESPECE_CATEGORY_CIV,
} from "constant/staticData/listEspeceCategory";
import axios from "axios";
// import { isSuperAdmin } from "utils/currentUserRole";

const UserDetails = () => {
  const { user, niveau, ApiService, handleLoad, canUpdate /* , roleTitle */ } =
    useContext(UserContext);
  const { getData, putData, postData } = ApiService;
  const navigate = useNavigate();
  const {
    PHONE_NUMBER_LENGTH,
    // DEFAULT_ENTITE,
    API_URL_TRACCAR,
    TRACCAR_EMAIL,
    TRACCAR_PSW,
    DECOUPAGE_ADMINISTRATIF,
    CODE_CLIENT,
  } = CONFIG;
  // const DECOUPAGE_ADMINISTRATIF = JSON.parse(DECOUPAGE_ADMINISTRATIF);
  // console.log("user", user);
  const LIST_ESPECE_CATEGORY =
    CODE_CLIENT === "ci" ? LIST_ESPECE_CATEGORY_CIV : LIST_ESPECE_CATEGORY_OTHER;

  const USER_DATA = userInfos();

  const [userDetails, setUserDetails] = useState(user ?? {});
  const [listProfil, setListProfil] = useState([]);
  const [listEntity, setListEntity] = useState([]);
  const [listTag, setListTag] = useState([]);
  const [lieuClassified, setLieuClassified] = useState({});

  const IsSuperAdmin = checkRoleExist(SUPER_ADMIN_ROLE);
  // const userEntity = normalizeText(userInfos()?.entite);
  // const userEntity = CurrentUserEntite();
  const goToMain = () => {
    const loadData = {
      isAlert: true,
      message: "Opération effectuée avec succès",
      isLoading: false,
      alertSeverity: "success",
    };
    handleLoad(loadData);
    setTimeout(() => {
      const lastPath = localStorage.getItem(LAST_PATH);
      navigate(lastPath);
    }, 200);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // console.log("sss ", name, value);
    let updatedUserDetails = {};
    if (["region", "departement", "commune"].includes(name)) {
      updatedUserDetails = handleLieuChange(userDetails, name, value);
    } else if (value.isSelect) {
      updatedUserDetails = handleSelectChange(userDetails, name, value);
      if (value.reason === "clear" && name === "fonction") {
        updatedUserDetails.fonction = "";
      }
    } else {
      updatedUserDetails = { ...userDetails, [name]: value };
    }
    setUserDetails(updatedUserDetails);
  };
  const handleSaveTraccarUser = async (userInfo) => {
    const endpoint = `${API_URL_TRACCAR}/api/users`;
    const auth = {
      username: TRACCAR_EMAIL,
      password: TRACCAR_PSW,
    };
    const data = {
      name: `${userInfo?.prenom ?? ""} ${userInfo?.nom ?? ""}`,
      email: `${userInfo?.matricul}@betaclic.com` ?? "",
      phone: userInfo?.numTel ?? "",
      password: userInfo?.matricul ?? "",
    };

    try {
      // const response =
      await axios.post(
        endpoint,
        data, // your JSON body
        {
          auth,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log(response.data);
      goToMain();
    } catch (error) {
      console.error("INnn", error);
      let msg = error?.response?.data;
      if (msg.includes("Duplicate entry")) {
        msg = "Le compte Traccar de cet utilisateur est déjà crée";
      }
      const loadData = {
        isAlert: true,
        message: msg,
        isLoading: false,
        alertSeverity: "error",
      };
      handleLoad(loadData);
    }
  };
  const linkUserTag = async (tagName) => {
    const endpoint = `tags/${tagName}/link/user`;
    const dataForm = [userDetails.numTel];

    const fetchData = await postData(endpoint, dataForm);
    let result = "";
    if (fetchData !== ERROR) {
      result = "success";
    } else {
      result = ERROR;
    }
    return result;
  };
  const unlinkUserTag = async (tagName) => {
    const endpoint = `tags/${tagName}/retrieve/user`;
    const dataForm = [userDetails.numTel];
    const fetchData = await postData(endpoint, dataForm);
    let result = "";
    if (fetchData !== ERROR) {
      result = "success";
    } else {
      result = ERROR;
    }
    return result;
  };
  /* const unlinkUserEntite = async () => {
    const endpoint = `Entite/retrieve/user`;
    const dataForm = [userDetails.numTel];
    const fetchData = await postData(endpoint, dataForm);
    let result = "";
    if (fetchData !== ERROR) {
      result = "success";
    } else {
      result = ERROR;
    }
    return result;
  };
  const linkUserEntite = async (entiteName) => {
    const endpoint = `Entite/${entiteName}/link/user`;
    const dataForm = [userDetails.numTel];
    const fetchData = await postData(endpoint, dataForm);
    let result = "";
    if (fetchData !== ERROR) {
      result = "success";
    } else {
      result = ERROR;
    }
    return result;
  };
  const activateUser = async () => {
    let linkEntity = null;
    let unlinkEntity = null;
    if (userDetails?.entity && Object.keys(userDetails?.entity).length !== 0) {
      if (!user?.entity) {
        linkEntity = await linkUserEntite(userDetails?.entity?.label);
      } else {
        // eslint-disable-next-line no-lonely-if
        if (user?.entity?.id !== userDetails?.entity?.id) {
          unlinkEntity = await unlinkUserEntite();
          linkEntity = await linkUserEntite(userDetails?.entity?.label);
        }
      }
    }
    let linkTag = null;
    let unlinkTag = null;

    // if (!user?.userTags) {
    if (!user?.userTags && userDetails?.userTags?.name) {
      linkTag = await linkUserTag(userDetails?.userTags?.name);
    } else {
      // eslint-disable-next-line no-lonely-if
      if (user?.userTags[0]?.tag?.id !== userDetails?.userTags?.id) {
        if (user?.userTags?.[0]?.tag?.name) {
          unlinkTag = await unlinkUserTag(user?.userTags[0]?.tag?.name);
        }
        // unlinkTag = await unlinkUserTag(userDetails?.userTags?.[1]?.tag?.name);
        // unlinkTag = await unlinkUserTag(userDetails?.userTags?.[0]?.tag?.name);
        if (userDetails?.userTags?.name) {
          linkTag = await linkUserTag(userDetails?.userTags?.name);
        }
      }
    }
    // }

    if (
      linkEntity !== ERROR &&
      unlinkEntity !== ERROR &&
      linkTag !== ERROR &&
      unlinkTag !== ERROR
    ) {
      goToMain();
    }
    // }
  };
  const saveRole = async () => {
    const endpoint = "Roles/assignUsersRoles";
    let role = "";
    if (niveau === "1A") {
      role = ADMIN_PAYS_ROLE;
    } else if (niveau === "1S") {
      role = SUPERVISEUR_ROLE;
    } else if (niveau === "2") {
      role = ADMIN_REGION_ROLE;
    } else if (niveau === "3") {
      role = ADMIN_DEPARTEMENTAL_ROLE;
    } else if (niveau === "4I") {
      role = AGENT_ROLE;
    }  else if (niveau === "4R") {
      role = RESPONSABLE_FERME;
    } else if (niveau === "5E") {
      role = ELEVEUR;
    } else if (niveau === "5P") {
      role = PROPRIETAIRE;
    }
    const roleUser = [
      {
        roleName: role,
        users: [
          {
            numTel: userDetails.numTel,
          },
        ],
      },
    ];
    const fetchData = await postData(endpoint, roleUser);
    if (fetchData !== ERROR) {
      activateUser();
    }
  }; */
  /* const handleInsertExploitant = async () => {
    let role = ELEVEUR;
    if (roleTitle === "Eleveur") {
      role = ELEVEUR;
    } else if (roleTitle === "Propriétaire") {
      role = PROPRIETAIRE;
    }
    let ferme = null;
    if (userDetails?.ferme) {
      ferme = {
        nom: userDetails?.ferme,
        fermeType: "PRIVATE",
      };
    }
    const CODE_PAYS = userInfos()?.lieu?.codePays;
    const newExploitant = {
      ...userDetails,
      lieu: {
        codePays: CODE_PAYS,
        codeCommune: userDetails?.lieu?.codeCommune,
        codeRegion: userDetails?.lieu?.codeRegion,
        codeDepart: userDetails?.lieu?.codeDepart,
      },
      roleName: role,
      ferme,
    };
    const endpoint = "auth/register/eleveur";
    const fetchData = await postData(endpoint, newExploitant);
    if (fetchData !== ERROR) {
      activateUser();
    }
  }; */

  const handleTagUser = async () => {
    let linkTag = null;
    let unlinkTag = null;
    let returnMsg = null;

    if (!user?.userTags && userDetails?.userTags?.name) {
      linkTag = await linkUserTag(userDetails?.userTags?.name);
    } else {
      // eslint-disable-next-line no-lonely-if
      if (user?.userTags[0]?.tag?.id !== userDetails?.userTags?.id) {
        if (user?.userTags?.[0]?.tag?.name) {
          unlinkTag = await unlinkUserTag(user?.userTags[0]?.tag?.name);
        }
        // unlinkTag = await unlinkUserTag(userDetails?.userTags?.[1]?.tag?.name);
        // unlinkTag = await unlinkUserTag(userDetails?.userTags?.[0]?.tag?.name);
        if (userDetails?.userTags?.name) {
          linkTag = await linkUserTag(userDetails?.userTags?.name);
        }
      }
    }
    if (linkTag !== ERROR && unlinkTag !== ERROR) {
      // goToMain();
      returnMsg = SUCCESS;
    } else {
      returnMsg = ERROR;
    }
    return returnMsg;
  };

  const handleInsertUser = async () => {
    let role = "";
    if (niveau === "1A") {
      role = ADMIN_PAYS_ROLE;
    } else if (niveau === "1S") {
      role = SUPERVISEUR_ROLE;
    } else if (niveau === "2") {
      role = ADMIN_REGION_ROLE;
    } else if (niveau === "3") {
      role = ADMIN_DEPARTEMENTAL_ROLE;
    } else if (niveau === "4I") {
      role = AGENT_ROLE;
    } /* else if (niveau === "4INS") {
      role = INSEMINATEUR_ROLE;
    } */ else if (niveau === "4R") {
      role = RESPONSABLE_FERME;
    } else if (niveau === "5E") {
      role = ELEVEUR;
    } else if (niveau === "5P") {
      role = PROPRIETAIRE;
    }
    // const endpoint = "register-user";
    const endpoint = "Users/save-list";
    const { userTags: _, ...rest } = userDetails;

    const payload = [
      {
        // ...userDetails,
        ...rest,
        roles: [
          {
            roleName: role,
            users: [
              {
                numTel: String(userDetails?.numTel),
              },
            ],
          },
        ],
      },
    ];
    // console.log("eee", payload);
    // if (endpoint === "") {
    // const fetchData = await postData(endpoint, userDetails);
    const fetchData = await postData(endpoint, payload);

    if (fetchData !== ERROR) {
      // saveRole();
      const tagSaving = await handleTagUser();
      console.log("aa ", tagSaving);

      if (API_URL_TRACCAR) {
        if (fetchData[0]?.matricul) {
          handleSaveTraccarUser(fetchData[0]);
        } else {
          const loadData = {
            isAlert: true,
            message: "Aucun matricule",
            isLoading: false,
            alertSeverity: "error",
          };
          handleLoad(loadData);
        }
      } else {
        goToMain();
      }
    }
  };
  const handleUpdateUser = async () => {
    const endpoint = "Users";
    const userInfo = {
      id: userDetails.id,
      nom: userDetails.nom,
      prenom: userDetails.prenom,
      numTel: userDetails.numTel,
      lieu: userDetails.lieu,
      fonction: userDetails.fonction,
      especeCategory: userDetails.especeCategory,
      enabled: userDetails?.enabled,
      entity: userDetails?.entity,
    };
    const fetchData = await putData(endpoint, [userInfo]);
    if (fetchData !== ERROR) {
      // activateUser();
      await handleTagUser();
      goToMain();
    }
  };
  const checkFormValues = async () => {
    let loadData = {
      isAlert: false,
      message: "",
      isLoading: false,
      alertSeverity: "error",
    };
    // console.log("ddd", userDetails?.entity);
    if (!userDetails?.prenom) {
      loadData = {
        isAlert: true,
        message: "Veuillez saisir le prenom",
        isLoading: false,
        alertSeverity: "error",
      };
    } else if (!userDetails?.nom) {
      loadData = {
        isAlert: true,
        message: "Veuillez saisir le nom",
        isLoading: false,
        alertSeverity: "error",
      };
    } else if (
      !userDetails?.numTel ||
      userDetails?.numTel?.length !== Number(PHONE_NUMBER_LENGTH)
    ) {
      loadData = {
        isAlert: true,
        message: "Veuillez saisir un numéro de téléphone valide",
        isLoading: false,
        alertSeverity: "error",
      };
    } else if (
      (!userDetails?.lieu?.codeCommune ||
        !userDetails?.lieu?.codeRegion ||
        !userDetails?.lieu?.codeDepart ||
        !userDetails?.lieu?.id) &&
      user === undefined
    ) {
      loadData = {
        isAlert: true,
        message: "Veuillez saisir un lieu : Region + Departement + Commune",
        isLoading: false,
        alertSeverity: "error",
      };
    } // else if (!userDetails?.entity || !userDetails?.entity?.label) {
    else if (!userDetails?.entity?.name) {
      // console.log("userDetails?.entity", !userDetails?.entity, !userDetails?.entity?.label);
      loadData = {
        isAlert: true,
        message: "Veuillez Choisir une entité (Structure privée, Direction, organisation...)",
        isLoading: false,
        alertSeverity: "error",
      };
    } else if (!userDetails?.especeCategory) {
      loadData = {
        isAlert: true,
        message: "Veuillez Choisir une catégorie d'espèce",
        isLoading: false,
        alertSeverity: "error",
      };
    } else {
      const userInDb = await searchUser(postData, userDetails?.numTel);
      if (userInDb?.length > 0 && (user === undefined || user?.numTel !== userDetails?.numTel)) {
        loadData = {
          isAlert: true,
          message: `Ce numéro de téléphone est déjà associé à l'utilisateur ${userInDb[0].prenom} ${userInDb[0].nom}`,
          isLoading: false,
          alertSeverity: "error",
        };
      } else {
        // eslint-disable-next-line no-lonely-if
        if (user === undefined) {
          /* if (roleTitle === "Eleveur" || roleTitle === "Propriétaire") {
            handleInsertExploitant();
          } else {
            handleInsertUser();
          } */
          handleInsertUser();
        } else {
          handleUpdateUser();
        }
      }
    }
    handleLoad(loadData);
  };
  // console.log("USER_DATA", userInfos());

  const fetchLieuData = async () => {
    const data = await getLieu(getData);

    const connectedUserNiveau = CurrentUserNiveau();
    // const USER_DATA = userInfos();

    // let lieuData = data;
    if (connectedUserNiveau > 1 && user === undefined) {
      const targetRegion = {
        name: "region",
        value: {
          newValue: USER_DATA?.lieu,
          isSelect: true,
          isResultObject: false,
          reason: "selectOption",
        },
      };
      handleInputChange({ target: targetRegion });
      if (connectedUserNiveau > 2) {
        const targetDepart = {
          name: "departement",
          value: {
            newValue: USER_DATA?.lieu,
            isSelect: true,
            isResultObject: false,
            reason: "selectOption",
          },
        };
        handleInputChange({ target: targetDepart });
      }
      // console.log("lieu", data, connectedUserNiveau, USER_DATA, target);
    }

    setLieuClassified(data);
  };
  const fetchProfilData = async () => {
    let niveauUser = "";
    if (user) {
      niveauUser = userDetails?.niveau;
    } else if (niveau) {
      niveauUser = niveau;
    }
    const customListProfil = await fetchCustomProfil(niveauUser);
    setListProfil(customListProfil);
  };
  const fetchEntityData = async () => {
    const data = await getEntity(getData);
    if (data !== ERROR) {
      setListEntity(data);
      if (
        user === undefined &&
        !IsSuperAdmin &&
        // !DEFAULT_ENTITE.includes(userEntity)
        !USER_DATA?.entite?.isAutorite
      ) {
        const defaultEntity = data.find((i) => i.name === userInfos()?.entite);
        setUserDetails({
          ...userDetails,
          entity: defaultEntity,
        });
      }
    }
  };
  const fetchTagData = async () => {
    const data = await getTag(getData);
    const filterTag = data.filter((i) => i.type === "USER");
    setListTag(filterTag);
  };

  useEffect(() => {
    fetchLieuData();
    fetchProfilData();
    fetchEntityData();
    fetchTagData();
  }, []);
  // console.log("sss", !isSuperAdmin);
  // console.log("sssY", user !== undefined && !canUpdate);
  // console.log("s", !IsSuperAdmin && !DEFAULT_ENTITE.includes(userEntity) && canUpdate);
  return (
    <Box
      sx={{ padding: 2, border: "1px solid #ccc", borderRadius: 2, margin: 2 }}
      style={{ backgroundColor: "white" }}
    >
      <Box textAlign="center">
        <Typography variant="h6">Informations de l&apos;utilisateur</Typography>
      </Box>

      <TextField
        label="Prénom *"
        name="prenom"
        value={userDetails.prenom}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            checkFormValues();
          }
        }}
        disabled={user !== undefined && !canUpdate}
      />
      <TextField
        label="Nom *"
        name="nom"
        value={userDetails.nom}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            checkFormValues();
          }
        }}
        disabled={user !== undefined && !canUpdate}
      />

      <TextField
        variant="outlined"
        margin="normal"
        fullWidth
        id="telephone"
        label="Numéro de téléphone *"
        name="numTel"
        type="number"
        onChange={handleInputChange}
        value={userDetails?.numTel ?? ""}
        inputProps={{ maxLength: Number(PHONE_NUMBER_LENGTH) }}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            checkFormValues();
          }
        }}
        disabled={user !== undefined && !canUpdate}
      />
      {/* (roleTitle === "Eleveur" || roleTitle === "Propriétaire") && !user && (
        <TextField
          // label="Exploitation"
          label="Ferme"
          name="ferme"
          value={userDetails.ferme ?? ""}
          onChange={handleInputChange}
          fullWidth
          margin="normal"
          disabled={user !== undefined && !canUpdate}
        />
      ) */}
      {lieuClassified?.listRegion && (
        <AutoCompleteComponent
          options={lieuClassified?.listRegion}
          name="region"
          // label="Region *"
          label={`${DECOUPAGE_ADMINISTRATIF?.[1]} *`}
          value={userDetails?.lieu?.region ?? ""}
          onChange={handleInputChange}
          isResultObject={false}
          onSubmit={checkFormValues}
          isDisabled
        />
      )}

      {lieuClassified?.listDepartement && (
        <AutoCompleteComponent
          options={lieuClassified?.listDepartement}
          name="departement"
          label={`${DECOUPAGE_ADMINISTRATIF?.[2]} *`}
          value={userDetails?.lieu?.departement ?? ""}
          onChange={handleInputChange}
          isResultObject={false}
          onSubmit={checkFormValues}
          isDisabled
        />
      )}

      {lieuClassified?.listCommune && (
        <AutoCompleteComponent
          options={lieuClassified?.listCommune}
          name="commune"
          label={`${DECOUPAGE_ADMINISTRATIF?.[3]} *`}
          value={userDetails?.lieu?.commune ?? ""}
          onChange={handleInputChange}
          isResultObject={false}
          onSubmit={checkFormValues}
          isDisabled={user !== undefined && !canUpdate}
        />
      )}
      {listProfil && (
        <AutoCompleteComponent
          options={listProfil}
          name="fonction"
          label="Profil"
          value={userDetails?.fonction ?? ""}
          onChange={handleInputChange}
          isResultObject={false}
          onSubmit={checkFormValues}
          isDisabled={user !== undefined && !canUpdate}
        />
      )}
      {listEntity && (
        <AutoCompleteComponent
          options={listEntity}
          name="entity"
          // label={`Entité (Structure Privée / Direction / organisation) ${!IsSuperAdmin ? "*" : ""}`}
          label="Entité (Structure Privée / Direction / organisation)*"
          value={userDetails?.entity?.name ?? ""}
          onChange={handleInputChange}
          isDisabled={(!IsSuperAdmin && !USER_DATA?.entite?.isAutorite) || !canUpdate}
          isResultObject
          // IsDisabled={user !== undefined && !canUpdate}
        />
      )}

      {listTag && (
        <AutoCompleteComponent
          options={listTag}
          name="userTags"
          label="Projet"
          value={userDetails?.userTags?.[0]?.tag?.name ?? userDetails?.userTags?.name ?? ""}
          // value={userDetails?.userTags?.[0]?.tag?.name ?? ""}
          onChange={handleInputChange}
          isResultObject
          // isDisabled={user !== undefined}
          isDisabled={user !== undefined && !canUpdate}
        />
      )}

      <AutoCompleteComponent
        options={LIST_ESPECE_CATEGORY}
        name="especeCategory"
        label="Catégorie d'espèce *"
        value={
          LIST_ESPECE_CATEGORY.find((item) => item.value === userDetails?.especeCategory)?.label ??
          ""
        }
        onChange={handleInputChange}
        // isResultObject
        // isDisabled={user !== undefined}
        isDisabled={user !== undefined && !canUpdate}
      />

      {canUpdate && (
        <Box display="flex" alignItems="center" justifyContent="center" gap={2}>
          <MDButton type="submit" variant="gradient" color="info" onClick={checkFormValues}>
            {!user ? "Enregistrer" : "Modifier"}
          </MDButton>
          {API_URL_TRACCAR && user && (
            <MDButton
              type="submit"
              variant="gradient"
              color="info"
              onClick={() => handleSaveTraccarUser(user)}
            >
              Créer un compte Traccar
            </MDButton>
          )}
        </Box>
      )}
    </Box>
  );
};

export default UserDetails;
